var React = require('react');

function CheckIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M44 24c0 11.046-8.954 20-20 20S4 35.046 4 24 12.954 4 24 4s20 8.954 20 20zm4 0c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24zm-14.586-3.586a2 2 0 1 0-2.828-2.828L21 27.172l-3.586-3.586a2 2 0 1 0-2.828 2.828L21 32.828l12.414-12.414z","fill":"#8D6CFF"}));
}

CheckIcon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = CheckIcon;

CheckIcon.default = CheckIcon;
